import { CheckNotes, InspectionCase } from '../inspection-cases';
import { AerosolArea } from './aerosol-area.dto';
import { AerosolShutdownMain } from './aerosol-shutdown-main.dto';

export class AerosolShutdownDesignDto extends InspectionCase {
  main?: AerosolShutdownMain;
  areas?: AerosolArea[];
}

export class AerosolShutdownDesign extends AerosolShutdownDesignDto {
  constructor(
    data: AerosolShutdownDesignDto = {
      title: 'תכנון / התקנה',
      isApplicable: true
    }
  ) {
    super(data);
    this.main = new AerosolShutdownMain(data.main);
    this.areas = data.areas
      ? data.areas.map((item) => new AerosolArea(item))
      : [new AerosolArea()];
  }

  setInspectionStatus(): void {
    this.main.setInspectionStatus();
    this.areas.forEach((item) => item.setInspectionStatus());
    this.isPassed = this.main.isPassed && this._isPassed();
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.main.getNotes()];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.main.setAsApplicable();
    this.areas.forEach((area) => area.setAsApplicable());
  }

  private _isPassed(): boolean {
    return !this.areas.some((item) => item.isApplicable && !item.isPassed);
  }
}
